module.exports = __webpack_public_path__ + "fonts/MavenPro-Light-300.98618f9b.otf";